package one.devsbox.www.theme

import androidx.compose.ui.graphics.Color

// Indigo Material System - Light Colors
val primaryLight = Color(0xFF24389C)
val onPrimaryLight = Color(0xFFFFFFFF)
val primaryContainerLight = Color(0xFF3F51B5)
val onPrimaryContainerLight = Color(0xFFCACFFF)
val secondaryLight = Color(0xFF5B5D6F)
val onSecondaryLight = Color(0xFFFFFFFF)
val secondaryContainerLight = Color(0xFFDDDEF4)
val onSecondaryContainerLight = Color(0xFF5F6174)
val tertiaryLight = Color(0xFF5A384F)
val onTertiaryLight = Color(0xFFFFFFFF)
val tertiaryContainerLight = Color(0xFF744F67)
val onTertiaryContainerLight = Color(0xFFF4C5E1)
val errorLight = Color(0xFFBA1A1A)
val onErrorLight = Color(0xFFFFFFFF)
val errorContainerLight = Color(0xFFFFDAD6)
val onErrorContainerLight = Color(0xFF93000A)
val backgroundLight = Color(0xFFF8F9FE)
val onBackgroundLight = Color(0xFF191C1F)
val surfaceLight = Color(0xFFF8F9FE)
val onSurfaceLight = Color(0xFF191C1F)
val surfaceVariantLight = Color(0xFFE1E2E7)
val onSurfaceVariantLight = Color(0xFF454652)
val outlineLight = Color(0xFF757684)
val outlineVariantLight = Color(0xFFC5C5D4)
val scrimLight = Color(0xFF000000)
val inverseSurfaceLight = Color(0xFF2E3134)
val inverseOnSurfaceLight = Color(0xFFEFF0F5)
val inversePrimaryLight = Color(0xFFBAC3FF)
val surfaceDimLight = Color(0xFFD8DADF)
val surfaceBrightLight = Color(0xFFF8F9FE)
val surfaceContainerLowestLight = Color(0xFFFFFFFF)
val surfaceContainerLowLight = Color(0xFFF2F3F8)
val surfaceContainerLight = Color(0xFFEDEEF3)
val surfaceContainerHighLight = Color(0xFFE7E8ED)
val surfaceContainerHighestLight = Color(0xFFE1E2E7)

// Original High-Contrast Dark Scheme Colors
val primaryDark = Color(0xFFD5BBFF)
val onPrimaryDark = Color(0xFF42008A)
val primaryContainerDark = Color(0xFFA874FF)
val onPrimaryContainerDark = Color(0xFF39007A)
val secondaryDark = Color(0xFFB6F330)
val onSecondaryDark = Color(0xFF243600)
val secondaryContainerDark = Color(0xFF9BD600)
val onSecondaryContainerDark = Color(0xFF3E5900)
val tertiaryDark = Color(0xFFFFB68D)
val onTertiaryDark = Color(0xFF532200)
val tertiaryContainerDark = Color(0xFFE07226)
val onTertiaryContainerDark = Color(0xFF481D00)
val errorDark = Color(0xFFFFB4AB)
val onErrorDark = Color(0xFF690005)
val errorContainerDark = Color(0xFF93000A)
val onErrorContainerDark = Color(0xFFFFDAD6)
val backgroundDark = Color(0xFF000000)
val onBackgroundDark = Color(0xFFE5E1E4)
val surfaceDark = Color(0xFF131315)
val onSurfaceDark = Color(0xFFE5E1E4)
val surfaceVariantDark = Color(0xFF353437)
val onSurfaceVariantDark = Color.Gray
val outlineDark = Color(0xFF968D9F)
val outlineVariantDark = Color(0xFF4A4453)
val scrimDark = Color(0xFF000000)
val inverseSurfaceDark = Color(0xFFE5E1E4)
val inverseOnSurfaceDark = Color(0xFF313032)
val inversePrimaryDark = Color(0xFF743CCB)
val surfaceDimDark = Color(0xFF131315)
val surfaceBrightDark = Color(0xFF39393B)
val surfaceContainerLowestDark = Color(0xFF0E0E10)
val surfaceContainerLowDark = Color(0xFF1B1B1D)
val surfaceContainerDark = Color(0xFF19191C)
val surfaceContainerHighDark = Color(0xFF2A2A2C)
val surfaceContainerHighestDark = Color(0xFF353437)

// Fixed Colors
val primaryFixed = Color(0xFFDEE0FF)
val primaryFixedDim = Color(0xFFBAC3FF)
val onPrimaryFixed = Color(0xFF00105C)
val onPrimaryFixedVariant = Color(0xFF293CA0)
val secondaryFixed = Color(0xFFE0E1F6)
val secondaryFixedDim = Color(0xFFC4C5DA)
val onSecondaryFixed = Color(0xFF181B2A)
val onSecondaryFixedVariant = Color(0xFF434657)
val tertiaryFixed = Color(0xFFFFD8EE)
val tertiaryFixedDim = Color(0xFFE8B9D5)
val onTertiaryFixed = Color(0xFF2E1126)
val onTertiaryFixedVariant = Color(0xFF5E3C53)
val surfaceTint = Color(0xFF4355B9)

// Industrial Colors (Retained for visual overlays and status indicators)
val outlineIndustrial = Color(0xFF4A4453)
val glowActive = Color(0x6624389C)
val glowScheduled = Color(0x66DDDEF4)
val glowPaused = Color(0x66EDEEF3)
